import { config } from '../../config/Constants';
import Axios from 'axios';

export const getTrackingStatus = async (data) => {
    try {
      const response = await Axios.get(config.url.GET_TRACKING_SERVICE, {
        params: data,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      return { error: true, trackingNumber: data.trackingNumber };
    }
  };